// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .articleline-reset {
  font-size: 16px;
  padding: 6px;
  margin: 4px 0 0 4px;
  border-radius: 2px;
}
.presize-root .articleline-reset:hover {
  background-color: #efeff0;
}
.presize-root .main-fields {
  margin-right: 5px;
}
.presize-root .main-fields span {
  text-decoration: underline;
  cursor: pointer;
}
.presize-root .main-fields .article-name-separator {
  text-decoration: none;
}
.presize-root .secondary-fields {
  font-size: 12px;
}
.presize-root .article .editable-cell-input {
  padding-right: 2px;
}
.presize-root .article-name-separator:before {
  content: '·';
  margin: 0 8px;
}
/*# sourceMappingURL=ArticleLine.css.map */`, "",{"version":3,"sources":["webpack://./ArticleLine.less","webpack://./src/components/SizingGroup/ArticleList/ArticleLine/ArticleLine.less"],"names":[],"mappings":"AAAA;EAEE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;ACAF;ADLA;EAQE,yBAAA;ACAF;ADRA;EAWE,iBAAA;ACAF;ADXA;EAaI,0BAAA;EACA,eAAA;ACCJ;ADfA;EAiBI,qBAAA;ACCJ;ADlBA;EAqBE,eAAA;ACAF;ADrBA;EAwBI,kBAAA;ACAJ;ADxBA;EA4BI,YAAA;EACA,aAAA;ACDJ;AACA,0CAA0C","sourcesContent":[".presize-root { \n .articleline-reset {\n  font-size: 16px;\n  padding: 6px;\n  margin: 4px 0 0 4px;\n  border-radius: 2px;\n}\n.articleline-reset:hover {\n  background-color: #efeff0;\n}\n.main-fields {\n  margin-right: 5px;\n  span {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  .article-name-separator {\n    text-decoration: none;\n  }\n}\n.secondary-fields {\n  font-size: 12px;\n}\n.article .editable-cell-input {\n    padding-right: 2px;\n}\n\n.article-name-separator:before {\n    content: '·';\n    margin: 0 8px;\n}\n \n}",".presize-root .articleline-reset {\n  font-size: 16px;\n  padding: 6px;\n  margin: 4px 0 0 4px;\n  border-radius: 2px;\n}\n.presize-root .articleline-reset:hover {\n  background-color: #efeff0;\n}\n.presize-root .main-fields {\n  margin-right: 5px;\n}\n.presize-root .main-fields span {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.presize-root .main-fields .article-name-separator {\n  text-decoration: none;\n}\n.presize-root .secondary-fields {\n  font-size: 12px;\n}\n.presize-root .article .editable-cell-input {\n  padding-right: 2px;\n}\n.presize-root .article-name-separator:before {\n  content: '·';\n  margin: 0 8px;\n}\n/*# sourceMappingURL=ArticleLine.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
